module.exports = __webpack_public_path__ + "img/header-desktop-min.680cac12.jpg";